import { EditBase } from "../shared/edit.base";
import { Component, Inject } from "@angular/core";
import { ApplicationUserDataService } from "../../core/applicationusers.dataservice";
import { StateService, TransitionService } from "@uirouter/angular";
import { MatDialog } from "@angular/material/dialog";
import appSettings = require("../../core/appsettings");
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Component({
    selector: "crew-edit-applicationuser",
    template: require('./application-user.edit.component.html')
})
export class EditApplicationUser extends EditBase<Nema.Crew.Model.ApplicationUser> {

    isWindowsAuthentication: Observable<boolean>;

    constructor(
        stateService: StateService,
        transitionService: TransitionService,
        dialog: MatDialog,
        @Inject('applicationUser') applicationUser: Nema.Crew.Model.ApplicationUser,
        @Inject('roles') public roles: Nema.Crew.Model.Role[],
        @Inject(ApplicationUserDataService.Id) private applicationUserDataService: ApplicationUserDataService,
        @Inject('$log') $log: ng.ILogService,
        @Inject('isNew') isNew: boolean,
        settings: appSettings.AppSettingsService) {

        super(stateService, transitionService, dialog, applicationUser, applicationUserDataService, $log, isNew);

        if (!isNew) {
            (<any>this.entity.UserRoles).load();
        }

        this.isWindowsAuthentication = settings.isWindowsAuthentication().pipe(map(res => res.body));
    }

    isActive(active: any) {
        if (!active) {
            this.entity.PermissionRead = false;
            this.entity.PermissionWrite = false;
            this.entity.PermissionAdmin = false;
        }
    }

    public entityDisplayName = "User";

    public listStateName = "app.settings.applicationusers";

    public addRole(): void {
        var newRole = this.applicationUserDataService.newUserRole(this.roles[0].Id);
        this.entity.UserRoles.push(<any>newRole);
    }

    public removeRole(userRole: Nema.Crew.Model.UserRole): void {
        var index = this.entity.UserRoles.indexOf(userRole, 0);
        if (index > -1) {
            var userRoleToDelete = this.entity.UserRoles[index];
            this.applicationUserDataService.removeMapping(userRoleToDelete, () => this.entity.UserRoles.splice(index, 1));
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/applicationusers/application-user.edit.component.ts